import React from 'react'
import AboutComponent from '../components/AboutComponent'
// import WhyChooseUs from '../components/WhyChooseUs'
import FAQs from '../components/FAQs'

const AboutUs = () => {
  return (
    <div>
        <AboutComponent/>
        {/* <WhyChooseUs/> */}
        <FAQs/>
    </div>
  )
}

export default AboutUs

